<template>
  <div class="pro-d-content">
    <div>
      <span class="pro-d-index">{{ statIndex }}</span
      ><span class="pro-d-name">{{ statName }}</span>
      <span v-if="!this.stats.visible" class="pro-d-visible">
        <v-icon color="secondary">mdi-eye-off</v-icon>
      </span>
    </div>
    <svg :class="className" viewBox="0 0 300 300">
      <line x1="10" y1="0" x2="285" y2="0" />
      <line x1="10" y1="75" x2="285" y2="75" />
      <line x1="10" y1="150" x2="285" y2="150" />
      <line x1="10" y1="225" x2="285" y2="225" />
      <text x="12" y="45">H</text>
      <text x="12" y="120">M</text>
      <text x="12" y="190">L</text>

      <rect
        class="m-rect"
        x="65"
        :y="this.calculateBarParams(this.stats.mission).y"
        width="60"
        :height="this.calculateBarParams(this.stats.mission).height"
      />
      <rect
        class="c-rect"
        x="125"
        :y="this.calculateBarParams(this.stats.competency).y"
        width="60"
        :height="this.calculateBarParams(this.stats.competency).height"
      />
      <rect
        class="s-rect"
        x="185"
        :y="this.calculateBarParams(this.stats.style).y"
        width="60"
        :height="this.calculateBarParams(this.stats.style).height"
      />

      <text class="mcs" x="87" y="220">M</text>
      <text class="mcs" x="147" y="220">C</text>
      <text class="mcs" x="210" y="220">S</text>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    stats: { type: Object, default: () => {} }
  },
  computed: {
    statName() {
      let parts = this.stats.name.split("_")
      parts.splice(0, 1)
      return parts.join(" ")
    },
    statIndex() {
      return this.stats.name.split("_")[0]
    },
    className() {
      return this.stats.visible ? "" : "invisible-box"
    }
  },
  methods: {
    calculateBarParams(value) {
      let bottomPosition = 225
      let countSize = 25

      let height = value * countSize
      let y = bottomPosition - height

      return { y: y, height: height }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.pro-d-content {
  margin: 0px 0px 0px 20px;
  color: $dark-grey;
}
.pro-d-name {
  font-style: italic;
  text-transform: uppercase;
  font-size: 0.6em;
}

.invisible-box {
  background-color: $beige;
}

.pro-d-visible {
  padding: 0px 0px 0px 3px;
}

.pro-d-index {
  color: $pro-d-graph-grey;
  padding: 0px 15px 0px 15px;
  font-size: 0.8em;
}

line {
  stroke: $light-grey;
  stroke-width: 1px;
}

text {
  fill: $pro-d-graph-grey;
}

.mcs {
  fill: $white;
}

rect {
  stroke-width: 0px;
}

.m-rect {
  fill: $pro-d-m;
}
.c-rect {
  fill: $pro-d-c;
}
.s-rect {
  fill: $pro-d-s;
}
</style>
